import { isBrowser } from 'app/libs/environment';

export const getSessionItem = (key) => (isBrowser && window.sessionStorage ? JSON.parse(window.sessionStorage.getItem(key)) : undefined);
export const setSessionItem = (key, data) => isBrowser && window.sessionStorage && window.sessionStorage.setItem(key, JSON.stringify(data));
export const removeSessionItem = (key) => (isBrowser && window.sessionStorage ? window.sessionStorage.removeItem(key) : {});

export const getLocalItem = (key) => (isBrowser && window.localStorage ? JSON.parse(window.localStorage.getItem(key)) : undefined);
export const setLocalItem = (key, data) => isBrowser && window.localStorage && window.localStorage.setItem(key, JSON.stringify(data));
export const removeLocalItem = (key) => (isBrowser && window.localStorage ? window.localStorage.removeItem(key) : {});
